module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"pageLoading.tip":"กำลัง Load ข้อมูล, กรุณารอสักครู่ ..."}}')
  delete Component.options._Ctor
}
